import { Styled } from './AppWrapper.styles';

// App Wrapper Component
function AppWrapper({ children }) {
  return <Styled.AppWrapper>{children}</Styled.AppWrapper>;
}

export { AppWrapper };
